import React, { useRef } from "react"
import { useReadMoreButton } from "../../hooks"


const WeddingSongPlan = ({ htmlLeft, htmlRight, borderBottom }) => {
  const weddingSongPlan = useRef(null)

  useReadMoreButton(weddingSongPlan, "Read More", "Read Less")

  return (
    <div ref={weddingSongPlan}>
      <div className="max-w-screen-2xl w-full mx-auto mt-7 lg:mt-[146px] flex flex-col items-center lg:flex-row lg:items-start justify-between px-7">
        <div
          className="lg:w-1/2 mb-10 lg:mb-0 font-montserrat--18 lg:leading-[57px] lg:pr-7"
          dangerouslySetInnerHTML={{ __html: htmlLeft }}
        ></div>
        <div
          className="lg:w-5/12 w-full"
          dangerouslySetInnerHTML={{ __html: htmlRight }}
        ></div>
      </div>
      {borderBottom && (
        <div className="border-b mt-20 mx-10 2xl:mx-auto lg:max-w-screen-2xl"></div>
      )}
    </div>
  )
}

export default WeddingSongPlan
